var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackOrderSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 304,
    viewBox: "0 0 364 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.972549 177.702C5.33604 168.241 14.9885 161.66 26.2048 161.66C28.8397 161.66 31.387 162.032 33.803 162.71C35.6179 149.327 47.2178 139.004 61.2659 139.004C71.9558 139.004 81.226 144.983 85.8495 153.735C90.5953 149.979 96.6153 147.726 103.17 147.726C118.479 147.726 130.889 159.981 130.889 175.098C130.889 175.978 130.842 176.844 130.76 177.702H0.972549Z",
    fill: "#C8C1AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M364 236.671C359.637 227.209 349.984 220.629 338.768 220.629C336.133 220.629 333.586 221 331.17 221.679C329.355 208.296 317.755 197.973 303.707 197.973C293.017 197.973 283.747 203.952 279.123 212.704C274.377 208.948 268.357 206.695 261.803 206.695C246.494 206.695 234.084 218.95 234.084 234.067C234.084 234.946 234.13 235.813 234.213 236.671H364Z",
    fill: "#C8C1AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.424 299.963L144.184 303.147C144.184 303.147 141.382 197.972 141.421 197.912C171.245 170.619 262.661 194.728 262.661 194.728L265.424 299.963Z",
    fill: "#CFAA52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M262.666 194.726L141.422 197.91L157.548 179.394L245.592 177.082L262.666 194.726Z",
    fill: "#C8C1AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.336 293.529L155.185 294.058L154.809 279.727L174.959 279.197L175.336 293.529Z",
    fill: "#FFFFF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.332 196.628C190.144 196.677 191.157 228.05 191.157 228.05L193.187 226.219L194.057 227.974L195.715 226.521L196.495 227.91L197.57 226.547L198.274 227.863L199.396 225.387L201.015 227.791L203.31 224.84L204.127 227.709L204.755 226.137L205.521 227.155L206.957 225.337L208.5 227.595L210.069 225.181L211.624 227.96L212.243 226.087L213.031 227.923L213.797 225.974L215.243 227.418L214.418 195.996C214.418 195.996 195.05 190.129 190.332 196.628Z",
    fill: "#F5E9D1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217.183 301.227L216.593 278.748L214.584 281.383L213.693 278.824L212.05 280.912L211.256 278.888L210.196 280.852L209.477 278.934L208.386 282.515L206.736 279.006L204.473 283.264L203.622 279.088L203.014 281.364L202.234 279.878L200.819 282.5L199.249 279.203L197.708 282.687L196.12 278.641L195.522 281.346L194.712 278.678L193.97 281.494L192.507 279.38L193.097 301.86L217.183 301.227Z",
    fill: "#F5E9D1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M214.418 195.993L212.893 183.112L212.037 184.436L211.179 183.157L209.512 184.231L208.743 183.221L207.657 184.226L206.963 183.268L205.825 185.089L204.221 183.34L203.093 185.488L202.296 183.39L201.657 184.545L200.898 183.806L199.448 185.149L197.923 183.505L196.337 185.285L194.802 183.26L194.169 184.634L193.394 183.297L192.616 184.728L191.179 183.682L190.332 196.626L214.418 195.993Z",
    fill: "#FEFEE1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M152.541 187.539L252.085 184.925",
    stroke: "#1B1736",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201.881 177.412L205.119 300.729",
    stroke: "#1B1736",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200.326 1.17859C200.211 1.17986 200.095 1.18581 199.976 1.18711L199.978 1.18553C140.962 2.05244 93.6885 50.3673 94.1025 109.383C105.631 97.5991 124.53 97.392 136.313 108.921L136.75 109.347L136.752 109.347L137.179 108.911C148.707 97.127 167.605 96.9199 179.39 108.449L179.775 108.826L179.766 108.873L179.794 108.843L179.822 108.87L179.824 108.869L179.837 108.798L180.186 108.442C191.715 96.6589 210.614 96.4518 222.398 107.979L222.834 108.407L222.837 108.407L222.857 108.385L223.263 107.97C234.79 96.1868 253.692 95.9797 265.476 107.507L265.9 107.926L265.932 107.892L266.32 107.498C277.848 95.715 296.746 95.5079 308.53 107.035L308.966 107.463C308.315 48.1137 259.675 0.528227 200.326 1.17859Z",
    fill: "#FFFFF5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M199.408 1.1961C140.394 2.06142 93.1201 50.3778 93.5342 109.395C105.063 97.6112 123.96 97.4041 135.744 108.933L136.18 109.358C124.242 28.3888 198.786 1.41999 199.408 1.1961Z",
    fill: "#650D1B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M199.818 1.18566C199.685 1.18712 199.554 1.1948 199.423 1.19624C168.98 49.6874 179.241 108.792 179.258 108.88L179.678 108.449C191.205 96.6659 210.105 96.4588 221.89 107.986L222.325 108.414L222.347 108.392C222.502 107.3 230.657 48.6039 199.426 1.20089C199.426 1.20089 275.589 26.387 265.422 107.899L265.81 107.505C277.339 95.7205 296.236 95.5134 308.02 107.042L308.456 107.47C307.805 48.1224 259.167 0.5353 199.818 1.18566Z",
    fill: "#650D1B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M222.708 108.385L202.207 186.122L179.617 108.871",
    stroke: "#1B1736",
    strokeWidth: 2.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M136.551 109.348L202.211 186.122",
    stroke: "#1B1736",
    strokeWidth: 2.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9004 109.385L202.213 186.123",
    stroke: "#1B1736",
    strokeWidth: 2.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M265.783 107.894L202.209 186.121",
    stroke: "#1B1736",
    strokeWidth: 2.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M308.818 107.461L202.208 186.123",
    stroke: "#1B1736",
    strokeWidth: 2.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackOrderSecond);
export default __webpack_public_path__ + "static/media/trackOrderSecond.342a99be1fc1427106d781d503dfad02.svg";
export { ForwardRef as ReactComponent };